<template>
  <div :class="$style.container">
    <template v-if="showHeader && type">
      <li
        :class="[$style.dropDownHeader, $style.header, { [$style.headerBorder]: index }]"
        role="presentation"
      >
        <header class="dropdown-header">
          {{ type }}
        </header>
      </li>
      <li
        :class="$style.dropDownDivider"
        role="presentation"
      >
        <hr
          aria-orientation="horizontal"
          class="dropdown-divider"
          role="separator"
        >
      </li>
    </template>
    <BDropdownItem
      :class="getDropDownMenuItemClass"
      :disabled="isDisabled"
      @click="onClick"
    >
      <div :class="[$style.selectIconListItemText, { [$style.disabled] : isDisabled}]">
        <i
          v-if="iconClassName"
          :class="[$style.dropdownIcon, iconClassName]"
        />
        <span
          v-if="!styledText"
        > {{ text }} </span>
        <CustomSelectIconListItemText
          v-if="styledText"
          :styledText="styledText"
        />
      </div>
    </BDropdownItem>
  </div>
</template>
<script>
import { BDropdownItem } from 'bootstrap-vue';
import CustomSelectIconListItemText from 'client/components/ItemTable/BodyComponents/CustomSelectIconListItemText.vue';

export default {
  name: 'CustomSelectIconListItem',

  components: {
    BDropdownItem,
    CustomSelectIconListItemText,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconClassName: {
      type: [Array, String],
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    onClick: {
      type: Function,
      required: true,
    },
    selected: {
      type: String,
      default: null,
    },
    showHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
    styledText: {
      type: Object,
      default: undefined,
      required: false,
    },
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: '',
      required: false,
    },
  },

  computed: {
    getDropDownMenuItemClass() {
      const classes = [this.$style.dropDownMenuItem];
      if (this.selected && this.selected === this.text) {
        classes.push(this.$style.dropDownMenuItemActive);
      }
      if (this.disabled) {
        classes.push(this.$style.dropDownMenuItemDisabled);
      }
      return classes;
    },
  },
};
</script>
<style module>
@import '../../FormValidation/css/formFields.css';

/* global dropdown header classes from action bar filter view in item table */
.dropDownDivider {
  margin: 8px 0;
}

.dropDownDivider hr {
  margin: 0;
}

.dropDownHeader.header {
  padding: 0 16px;
}

.dropDownMenuItem :global(.dropdown-item) {
  padding: 0.25rem 16px;
}

.dropDownHeader :global(.dropdown-header) {
  color: var(--jcGrey600);
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0;
  white-space: normal;
}

.selectIconListItemText {
  display: flex;
  flex-direction: row;
  font-size: 1rem;
}

.selectIconListItemText span {
  white-space: normal;
}

.disabled .dropdownIcon {
  color: var(--jcGrey600);
}

.disabled span {
  color: var(--jcGrey400);
}

.container .headerBorder {
  border-top: var(--jc-border-width-double) solid var(--jc-border-color);
  margin-top: 0.54rem;
  padding-top: 0.54rem;
}

</style>
